<template>
  <section class="account-details">
    <Breadcrumbs
      :breadcrumbs="breadcrumbs" />

    <div class="row" v-if="account">

      <div class="col-12 col-sm-12">
        <user-info :account="account"></user-info>
      </div>

      <!-- <div class="col-12 col-sm-6">
        <access-info :account="account"></access-info>
      </div> -->

    </div>

    <div class="mb-3">
      <va-tabs v-model="tabValue" style="border-width: 2px">
        <va-tab
          v-for="tab in viewType"
          :key="tab"
        >
          {{ $t(`accounts.detailed_view_type.${tab}`)}}
        </va-tab>
      </va-tabs>
    </div>
    <section v-if="account && tabValue === 0">
      <div>
        <HearingTestsTable
          :account="account"
          :service="component.service"
          class="mb-3"
        />
        <HearingTrainingLevels
          :account="account"
          :service="component.service"
          class="mb-3"
        />

        <div v-if="availableA4ATests.length > 0" v-for="item in availableA4ATests">
          <A4ATestTable
            :account="account"
            :service="component.service"
            :test="item"
            class="mb-3"/>
        </div>
      </div>

    </section>
    <section v-if="account && tabValue === 1">
      <A4ATestSessionsTable
        :account="account"
        :service="component.service"
        class="mb-3"/>
    </section>
  </section>
</template>

<script>
import UserInfo from './UserInfo'
import AccessInfo from './AccessInfo'
import HearingTestsTable from './HearingTestsTable'
import { AccountService } from '@/api/AuthClinicalService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import HearingTrainingLevels from './HearingTrainingLevels'
import {A4AService} from "@/api/A4AService";
import A4ATestTable from "@/components/clinical/accounts/AccountDetails/A4A/A4ATestCard";
import A4ATestSessionsTable from "@/components/clinical/accounts/AccountDetails/A4A/A4ATestSessionsTable.vue";

export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  components: {
    A4ATestSessionsTable,
    A4ATestTable,
    UserInfo,
    AccessInfo,
    Breadcrumbs,
    HearingTestsTable,
    HearingTrainingLevels
  },
  data: function () {
    return {
      tabValue: null,
      viewType: ['by_test', 'by_test_session'],
      account: null,
      availableA4ATests: [],
      breadcrumbs: [
        { title: this.$t('menu.clinical_audiology'), disabled: true },
        { title: this.$t('menu.clinical/accounts'), meta: { type: 'function', value: () => this.$router.go(-1) } }
      ]
    }
  },
  methods: {
    selectAccount: function (accountId) {
      AccountService.get(this.component.service.url, accountId)
        .then(account => {
          this.account = account
          this.breadcrumbs.push({ title: this.account.name, active: true })
        })
        .catch(errors => {
          console.log(errors)
          this.$router.go(-1)
        })
    }
  },
  created: async function () {
    this.availableA4ATests = await A4AService.getAllAvailableTests()
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.id !== undefined) {
      next(vm => {
        vm.selectAccount(parseInt(to.params.id))
        vm.from = from
      })
    } else {
      next(from)
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.id !== undefined) {
      this.selectAccount(parseInt(to.params.id))
    } else {
      next(from)
    }
  }
}
</script>
